<template>
  <wizard-form v-bind="ouiaProps" :hidden="hidden" :title="$t('Location')">
    <wizard-question :title="$t('Location principale')">
      <wizard-question-location
        :model-value="wizard.sceltaLocationDeploy"
        @update:model-value="wizard.sceltaLocationDeploy = $event as (typeof REGION)[number]"
        name="deployLocation"
        :opzioni-location="wizard.locations"
      />
    </wizard-question>

    <wizard-question v-if="wizard.askRegionBackup" :title="$t('Location di backup')">
      <template #description>
        <p>{{ $t('I backup sono sempre salvati in una farm separata dalla location principale.') }}</p>
      </template>
      <wizard-question-location
        :model-value="wizard.sceltaLocationBackup"
        @update:model-value="wizard.sceltaLocationBackup = $event as (typeof REGION)[number]"
        name="backupLocation"
        :opzioni-location="wizard.locations"
        :disabled="wizard.path !== 'cloud'"
      />
    </wizard-question>
  </wizard-form>
</template>

<script lang="ts" setup>
import { $t as _t } from '@/i18n';
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { useWizardStep } from '@/wizard';
import WizardForm from '../wizard-form.vue';
import WizardQuestion from '../questions/wizard-question.vue';
import WizardQuestionLocation from '../questions/wizard-question-location.vue';
import { REGION } from '@common/consts';

defineOptions({
  name: 'WizardStepLocation',
});

const props = defineProps<OUIAProps>();
const ouiaProps = useOUIAProps(props);

const { wizard, hidden, isEnabled } = useWizardStep({
  isEnabled: wizard => wizard.askRegion,
});

defineExpose({
  isEnabled,
});
</script>
